import { useCallback } from 'react';

import { ContentContainer } from '../../../components/Filters/components/ContentContainer';
import { ControlsPanel } from '../../../components/Filters/components/ControlsPanel';
import { TagsHierarchyChooser } from '../../../components/TagsHierarchyChooser/TagsHierarchyChooser';
import { useSearchContext } from '../contexts';

export const TagsChooser = () => {
  const { state, updateDraftFilters } = useSearchContext();

  const selected = state.draftFilters.tags.value;

  const handleChange = useCallback(
    (newSelected: string[]) => {
      updateDraftFilters({
        tags: {
          value: newSelected,
          exclude: state.draftFilters.tags.exclude,
        },
      });
    },
    [state.draftFilters.tags.exclude, updateDraftFilters],
  );

  const handleClearAll = () => {
    updateDraftFilters({
      tags: {
        value: [],
        exclude: false,
      },
    });
  };

  return (
    <ContentContainer
      actionsComponent={
        <ControlsPanel
          id="tags-filter"
          count={selected.length}
          isExclude={state.draftFilters.tags.exclude}
          showExcludeSwitch={true}
          showSelectAll={false}
          onClearAll={handleClearAll}
          onExcludeClick={() => {
            updateDraftFilters({
              tags: {
                value: state.draftFilters.tags.value,
                exclude: !state.draftFilters.tags.exclude,
              },
            });
          }}
        />
      }
    >
      <TagsHierarchyChooser selected={selected} onChange={handleChange} mode="modern" />
    </ContentContainer>
  );
};
